import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=5bdf2929"
import script from "./TextareaComponent.vue?vue&type=script&lang=js"
export * from "./TextareaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/TextareaComponent.vue
// module id = null
// module chunks = 